<template>
<span class="noSelect"
	:class="wrapClasses"
	@click="toggle"
	@keydown.space="toggle"
>
	<input type="hidden" :name="name" :value="currentValue">
	<span :class="innerClasses">
		<slot name="open" v-if="currentValue === trueValue"></slot>
		<slot name="close" v-if="currentValue === falseValue"></slot>
	</span>
	<div v-if="mode=='switch'" class="switchList tableSys taC curP fSub vaM_E">
		<slot name="switchList"></slot>
	</div>
</span>
</template>
<script>
	function oneOf (value, validList) {
		for (let i = 0; i < validList.length; i++) {
			if (value === validList[i]) {
				return true;
			}
		}
		return false;
	}
	export default {
		name: 'OnOff',
		props: {
			value: {
				type: [String, Number, Boolean],
				default: false
			},
			trueValue: {
				type: [String, Number, Boolean],
				default: true
			},
			falseValue: {
				type: [String, Number, Boolean],
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
			size: {
				validator (value) {
					return oneOf(value, ['large', 'small', 'default']);
				}
			},
			name: {
				type: String
			},
			loading: {
				type: Boolean,
				default: false
			},
			mode:{//模式：onOff带有背景变化，switch没有背景变化
				type:String,
				default:"onOff"
			}
		},
		data () {
			return {
				currentValue: this.value
			};
		},
		watch: {
			value (val) {
				if (val !== this.trueValue && val !== this.falseValue) {
					throw 'Value should be trueValue or falseValue.';
				}
				this.currentValue = val;
			}
		},
		computed: {
			wrapClasses () {
				return [
					'onOff',
					{
						['onOff-checked']: this.currentValue === this.trueValue,
						['onOff-disabled']: this.disabled,
						[`onOff-${this.size}`]: !!this.size,
						['onOff-loading']: this.loading,
					},
					{curP:this.mode=="onOff"},
					{
						"onOff-switch":this.mode=="switch"
					}
				];
			},
			innerClasses () {
				return 'onOff-inner';
			}
		},
		methods: {
			toggle (event) {
				event.preventDefault();
				if (this.disabled || this.loading) {
					return false;
				}
				const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue;
				this.currentValue = checked;
				this.$emit('input', checked);
				this.$emit('on-change', checked);
			},
			setValue:function(val=false){//设置值
				this.currentValue=val;
			}
		}
	};
</script>
<style lang="scss" scoped="scoped">
$width:4rem;
$switchWidth:5rem;
$height:2rem;
$btnWidth:$height - .4;
$switchBtnWidth:$height * 1.2;
$defBg:$contentBgColor;

.onOff {width:$width;height:$width * 0.5;display:inline-block;box-shadow:0 0 2em rgba(#000,.2) inset;
	line-height:1.8rem;
	border-radius:$width;
	vertical-align:middle;
	background-color:$defBg;
	position:relative;
	transition:all .2s ease-in-out;

	&:active:after{width:$btnWidth * 1.6;}
	&:after {
		content:"";
		width:$btnWidth;
		height:$btnWidth;
		border-radius:$btnWidth;
		background-color:#fff;
		position:absolute;
		left:.2rem;
		top:.2rem;
		box-shadow:0 0 1rem rgba(#000,.2);
		transition:left .2s ease-in-out,width .2s ease-in-out;
	}

	&.onOff-checked{background-color:$mainColor;
		&:active:after{left:($width - $btnWidth * 1.6) - .2;}
		&:after{left:$width * 0.5 + .2;}
		&.onOff-switch{background-color:$defBg;
			&:active:after{left:($switchWidth - $switchBtnWidth * 1.2) - .2;}
			&:after{left:($switchWidth - $switchBtnWidth) - .2;}
		}
	}

	&.onOff-switch{width:$switchWidth;
		&:active:after{width:$switchBtnWidth * 1.2;}
		&:after{width:$switchBtnWidth;}
	}

	.switchList{line-height:1;position:relative;z-index:1;padding:{left:.2rem;right:.2em;};
		>*{height:$height;}
	}
}
.onOff-loading {
 opacity:.4
}
.onOff-inner {
 color:#fff;
 font-size:12px;
 position:absolute;
 left:23px
}
.onOff-inner i {
 width:12px;
 height:12px;
 text-align:center;
 position:relative;
 top:-1px
}
.onOff:before {
 content:"";
 display:none;
 width:14px;
 height:14px;
 border-radius:50%;
 background-color:transparent;
 position:absolute;
 left:3px;
 top:3px;
 z-index:1;
 -webkit-animation:onOff-loading 1s linear;
 animation:onOff-loading 1s linear;
 -webkit-animation-iteration-count:infinite;
 animation-iteration-count:infinite
}
.onOff-loading:before {
 display:block
}
.onOff:focus {
 box-shadow:0 0 0 2px rgba($mainColor,.2);
 outline:0
}
.onOff:focus:hover {
 box-shadow:none
}
.onOff-small {
 width:28px;
 height:16px;
 line-height:14px
}
.onOff-small:after {
 width:12px;
 height:12px
}
.onOff-small:active:after {
 width:14px
}
.onOff-small:before {
 width:10px;
 height:10px;
 left:2px;
 top:2px
}
.onOff-small.onOff-checked:after {
 left:13px
}
.onOff-small.onOff-checked:before {
 left:14px
}
.onOff-small:active.onOff-checked:after {
 left:11px
}
.onOff-large {
 width:56px
}
.onOff-large:active:after {
 width:26px;
 width:30px
}
.onOff-large.onOff-checked:after {
 left:35px
}
.onOff-large.onOff-checked:before {
 left:37px
}
.onOff-large:active.onOff-checked:after {
 left:23px
}
.onOff-largeBig {
	width:68px
}
.onOff-largeBig:active:after {
 width:26px;
 width:30px
}
.onOff-largeBig.onOff-checked:after {
 left:47px
}
.onOff-largeBig.onOff-checked:before {
 left:37px
}
.onOff-largeBig:active.onOff-checked:after {
 left:23px
}
.onOff-checked .onOff-inner {
 left:7px
}
.onOff-checked:before {
 left:25px
}
.onOff-disabled {
 cursor:not-allowed;
 opacity:.4
}
.onOff-disabled:after {
 background:#fff;
 cursor:not-allowed
}
.onOff-disabled .onOff-inner {
 color:#fff
}
.onOff-disabled.onOff-checked {
 background-color:$mainColor;
 opacity:.4
}
.onOff-disabled.onOff-checked:after {
 background:#fff
}
.onOff-disabled.onOff-checked .onOff-inner {
 color:#fff
}
@-webkit-keyframes onOff-loading {
 0% {
	-webkit-transform:rotate(0);
	transform:rotate(0)
 }
 to {
	-webkit-transform:rotate(1turn);
	transform:rotate(1turn)
 }
}
</style>


// WEBPACK FOOTER //
// src/components/common/ui/OnOff.vue